<template>
  <!-- eslint-disable-next-line vue/no-v-html -- Contentful-authored marketing copy rendered via marked -->
  <div
    class="price-rule-explainer-card"
    v-html="html"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { renderMarkdownToHtml } from '@/composables/contentful'

/**
 * Renders a price rule's `extendedDescription` markdown as the explainer card body — shared by the
 * desktop app-header hover popover and the mobile banner tap popover. The leading bold line in the
 * markdown is styled as the card title.
 */
export default defineComponent({
  name: 'PriceRuleExplainerCard',
  props: {
    markdown: {
      type: String,
      default: ''
    }
  },
  computed: {
    html(): string {
      return this.markdown ? renderMarkdownToHtml(this.markdown) : ''
    }
  }
})
</script>

<style scoped lang="scss">
.price-rule-explainer-card {
  text-align: left;
  color: #555;

  :deep(p) {
    margin: 0 0 0.75rem;
    font-size: 1rem;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }
  }

  // The authored markdown leads with a bold line that acts as the card title.
  :deep(p:first-child) {
    margin-bottom: 0.5rem;
    color: #2a2a2a;
    font-size: 1.25rem;
    font-weight: 700;
  }
}
</style>
